<template>
  <div v-cloak v-if="template" class="item-common pt-10 pb-15 px-7 type-school">
    <div class="header">
      <h1 class="title">
        {{ $t(template.schoolTitle) }}
        <span v-if="itemsMaxSize" class="max-length-guide">
          {{ $t('최대 입력 가능 갯수 : ') }} {{ $t(itemsMaxSize) }}</span
        >
      </h1>
      <v-divider></v-divider>
      <p class="desc" v-html="template.guideSchool"></p>
    </div>
    <div class="body">
      <v-form ref="saveForm" v-if="!isReadonly">
        <div class="mt-2" v-if="obj">
          <v-row>
            <v-col cols="12" class="col-md-11">
              <v-row>
                <v-col cols="12" class="col-md">
                  <DirectInputSelect
                    :useDirect="itemDirectInput('schoolType') == 'Y'"
                    :items="itemArray('schoolType')"
                    :label="itemLabel('schoolType')"
                    v-model="obj.schoolType"
                    v-maxlength="'school_type'"
                    outlined
                    dense
                    hide-details="auto"
                    :rules="[rules.required('schoolType', true)]"
                    @change="change(-1)"
                    :class="leftRoundedClass"
                    :readonly="isReadonly"
                  />
                </v-col>
                <v-col
                  cols="6"
                  class="col-md"
                  :class="colclass"
                  v-if="obj.testYn === 'N'"
                >
                  <CommonDatePicker
                    :readonly="isReadonly"
                    :label="itemLabel('schoolSdate')"
                    :rules="[
                      rules.required('schoolSdate', true),
                      rules.required('schoolSdate'),
                    ]"
                    useMaxCurrentDate
                    v-model="obj.startDate"
                    :disabled="!schoolAble(-1)"
                    :type="schoolTermFormat === 'YYYY.MM' ? 'month' : 'date'"
                  />
                </v-col>
                <v-col
                  cols="6"
                  class="col-md"
                  :class="colclass"
                  v-if="obj.testYn === 'N'"
                >
                  <DirectInputSelect
                    :useDirect="itemDirectInput('schoolStype') == 'Y'"
                    v-model="obj.schoolStype"
                    v-maxlength="'school_type'"
                    :items="itemArray('schoolStype')"
                    :label="itemLabel('schoolStype')"
                    outlined
                    dense
                    hide-details="auto"
                    :rules="[
                      rules.required('schoolStype', true),
                      rules.required('schoolStype'),
                    ]"
                    :class="rrzrclass"
                    :disabled="!schoolAble(-1)"
                    :readonly="isReadonly"
                  />
                </v-col>
                <v-col
                  cols="6"
                  class="col-md"
                  :class="colclass"
                  v-if="obj.testYn === 'N'"
                >
                  <CommonDatePicker
                    :readonly="isReadonly"
                    :label="itemLabel('schoolEdate')"
                    :rules="[
                      rules.required('schoolEdate', true),
                      rules.required('schoolEdate'),
                    ]"
                    v-model="obj.endDate"
                    :disabled="!schoolAble(-1)"
                    :min="obj.startDate"
                    :type="schoolTermFormat === 'YYYY.MM' ? 'month' : 'date'"
                  />
                </v-col>
                <v-col
                  cols="6"
                  class="col-md"
                  :class="colclass"
                  v-if="obj.testYn === 'Y'"
                >
                  <CommonDatePicker
                    :readonly="isReadonly"
                    label="합격일자"
                    useMaxCurrentDate
                    :rules="[
                      rules.required('schoolEdate', true),
                      rules.required('schoolEdate'),
                    ]"
                    v-model="obj.passDate"
                    :disabled="!schoolAble(-1)"
                    :type="schoolTermFormat === 'YYYY.MM' ? 'month' : 'date'"
                  />
                </v-col>
                <v-col cols="6" class="col-md" :class="colclass">
                  <DirectInputSelect
                    :useDirect="itemDirectInput('schoolEtype') == 'Y'"
                    v-model="obj.schoolEtype"
                    :items="itemArray('schoolEtype')"
                    v-maxlength="'school_etype'"
                    :label="itemLabel('schoolEtype')"
                    outlined
                    dense
                    hide-details="auto"
                    :rules="[
                      rules.required('schoolEtype', true),
                      rules.required('schoolEtype'),
                    ]"
                    :class="rrzrclass"
                    :disabled="!schoolAble(-1)"
                    :readonly="isReadonly"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col class="d-none d-md-block pl-3 col-md-1">
              <i-btn elevation="0" color="primary" block @click="add"
                >저장</i-btn
              >
            </v-col>
          </v-row>
          <template v-if="obj.testYn === 'N'">
            <v-row :class="rowclass">
              <v-col cols="6" class="col-md" :class="colclass">
                <CollectionAutoComplete
                  v-model="obj.schoolName"
                  :directInput="itemDirectInput('schoolName')"
                  :collectionType="
                    obj.schoolType === '고등학교' ? 'high' : 'grad'
                  "
                  :rules="[
                    rules.required('schoolName', true),
                    rules.maxlength('schoolName'),
                  ]"
                  itemKey="school"
                  :disabled="!schoolAble(-1)"
                  :label="itemLabel('schoolName')"
                  :readonly="isReadonly"
                  :campusShow="obj.schoolType === '고등학교' ? false : true"
                  @change:item="item => autocomsetName(-1, item)"
                  @keydown.tab="item => autocomsetName(-1, item)"
                />
              </v-col>
              <v-col
                cols="1"
                class="col-md-2"
                :class="colclass"
                v-if="obj.univYn === 'Y' || obj.schoolType === '고등학교'"
              >
                <DirectInputSelect
                  v-maxlength="'school_day_night'"
                  :useDirect="itemDirectInput('schoolDayNight') == 'Y'"
                  v-model="obj.schoolDayNight"
                  :items="['주간', '야간']"
                  :label="itemLabel('schoolDayNight')"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="[rules.required('schoolDayNight', true)]"
                  autocomplete="false"
                  :class="rrzrclass"
                  :readonly="isReadonly"
                  clearable
                  :disabled="!schoolAble(-1)"
                ></DirectInputSelect>
              </v-col>

              <v-col
                cols="6"
                class="col-md"
                :class="colclass"
                v-if="obj.univYn === 'Y'"
              >
                <CollectionAutoComplete
                  v-model="obj.schoolMajor"
                  :directInput="itemDirectInput('schoolMajor')"
                  :collectionType="
                    obj.schoolType === '고등학교' ? 'high' : 'grad'
                  "
                  :rules="[
                    rules.required('schoolMajor', true),
                    rules.maxlength('schoolMajor'),
                  ]"
                  itemKey="major"
                  :disabled="!schoolAble(-1)"
                  :label="itemLabel('schoolMajor')"
                  :readonly="isReadonly"
                  :campusShow="obj.schoolType === '고등학교' ? false : true"
                  @keydown.tab="item => autocomsetMajor(-1, item)"
                  @change:item="item => autocomsetMajor(-1, item)"
                />
              </v-col>
              <v-col
                cols="6"
                class="col-md-2"
                :class="colclass"
                v-if="obj.univYn === 'Y'"
              >
                <i-text-field
                  v-model="obj.schoolScore"
                  :label="itemLabel('schoolScore')"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="[
                    rules.required('schoolScore', true),
                    rules.maxlength('schoolScore'),
                    v => !v || !isNaN(v) || '숫자 형식으로 입력해 주세요',
                  ]"
                  :class="lrzrclass"
                  :disabled="!schoolAble(-1)"
                  @change="autocomsetScore(-1, obj)"
                ></i-text-field>
              </v-col>
              <v-col
                cols="6"
                class="col-md-2"
                :class="colclass"
                v-if="obj.univYn === 'Y'"
              >
                <DirectInputSelect
                  :useDirect="itemDirectInput('schoolScore') == 'Y'"
                  v-model="obj.schoolScoreUnit"
                  :items="itemArray('schoolScore')"
                  :label="itemLabel('schoolScore') + '기준'"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="[rules.required('schoolScore', true)]"
                  :readonly="isReadonly"
                  :disabled="!schoolAble(-1)"
                  @change="autocomsetScore(-1, obj)"
                />
              </v-col>
              <v-col
                cols="6"
                class="col-md-6"
                :class="colclass"
                v-if="obj.univYn === 'N'"
              >
                <DirectInputSelect
                  v-maxlength="'school_gubun'"
                  :useDirect="itemDirectInput('schoolGubun') == 'Y'"
                  v-model="obj.schoolGubun"
                  :items="itemArray('schoolGubun')"
                  label="계열"
                  outlined
                  dense
                  :readonly="isReadonly"
                  hide-details="auto"
                  :rules="[
                    rules.required('schoolGubun', true),
                    rules.maxlength('schoolGubun'),
                  ]"
                  class="rounded-r rounded-l-0"
                  :disabled="!schoolAble(-1)"
                />
              </v-col>
            </v-row>
            <v-row
              :class="rowclass"
              v-if="
                schoolMajorEtcUseYn == 'Y' &&
                  !['고등학교', '검정고시'].includes(obj.schoolType)
              "
            >
              <i-text-field
                v-maxlength="'school_major_etc'"
                v-model="obj.schoolMajorEtc"
                :label="itemLabel('schoolMajorEtc')"
                outlined
                dense
                :hint="template.opts.schoolMajorEtc.oGuide"
                hide-details="auto"
                :disabled="!schoolAble(-1)"
                :rules="[rules.required('schoolMajorEtc', true)]"
              />
            </v-row>
            <v-row
              :class="rowclass"
              v-if="
                schoolEtcUseYn == 'Y' &&
                  ['석사', '박사'].some(
                    v => obj.schoolType && obj.schoolType.includes(v),
                  )
              "
            >
              <i-text-field
                v-maxlength="'school_major_etc'"
                v-model="obj.schoolEtc"
                :label="itemLabel('schoolEtc')"
                outlined
                dense
                :hint="template.opts.schoolEtc.oGuide"
                hide-details="auto"
                :rules="[rules.required('schoolEtc', true)]"
              />
            </v-row>
          </template>

          <template v-if="obj.univYn === 'Y' && multiSubMajorUseYn === 'Y'">
            <v-row class="d-flex align-center justify-end mt-1">
              <v-icon
                v-show="!obj.deleteAble"
                class="cursor  hover-opacity"
                @click="addMajorSub(-1)"
              >
                {{ mdiAdd }}</v-icon
              >

              <v-icon
                @click="obj.deleteAble = !obj.deleteAble"
                :color="obj.deleteAble ? '#F44336' : null"
                class="ml-2 cursor hover-opacity"
              >
                {{ mdiEdit }}</v-icon
              >
            </v-row>
            <template v-for="(item, index) in obj.majorSubList">
              <v-row
                :class="index == 0 ? 'mt-1' : rowclass"
                :key="index + 'majorSub'"
              >
                <v-col cols="6" class="col-md-4" :class="colclass">
                  <i-select
                    v-model="item.schoolMajorSubType"
                    :items="subMajorItems"
                    label="전공추가선택"
                    outlined
                    dense
                    hide-details="auto"
                    class="rounded-l rounded-r-0"
                    :readonly="isReadonly"
                    :disabled="!schoolAble(-1)"
                  >
                    <template #prepend v-if="obj.deleteAble">
                      <v-icon
                        color="#F44336"
                        class="hover-opacity cursor"
                        @click="
                          obj.majorSubList.length > 1 &&
                            obj.majorSubList.splice(index, 1),
                            (obj.deleteAble = false)
                        "
                      >
                        {{ mdiDelete }}
                      </v-icon>
                    </template>
                  </i-select>
                </v-col>
                <v-col cols="6" class="col-md-8" :class="colclass">
                  <CollectionAutoComplete
                    v-model="item.schoolMajorSub"
                    :directInput="'Y'"
                    :rules="[
                      rules.required('schoolMajorSub', true),
                      rules.maxlength('schoolMajorSub'),
                    ]"
                    itemKey="major"
                    :disabled="!schoolAble(-1)"
                    :label="itemLabel('schoolMajor')"
                    :readonly="isReadonly"
                    @change:item="item => autocomsetSubMajor(-1, item, index)"
                  />
                </v-col>
              </v-row>
              <v-row
                :class="rowclass"
                v-if="schoolMajorEtcUseYn == 'Y'"
                :key="'subItemObjEtc' + index"
              >
                <i-text-field
                  v-maxlength="'school_major_sub_etc'"
                  v-model="item.schoolMajorSubEtc"
                  :label="itemLabel('schoolMajorEtc')"
                  outlined
                  dense
                  :hint="template.opts.schoolMajorEtc.oGuide"
                  hide-details="auto"
                  :disabled="!schoolAble(-1)"
                  :rules="[
                    v =>
                      (!item.schoolMajorSubType && !item.schoolMajorSub) ||
                      rules.required('schoolMajorEtc', true)(v),
                  ]"
                >
                  <template #prepend v-if="obj.deleteAble">
                    <div style="height:24px;width:24px;"></div>
                  </template>
                </i-text-field>
              </v-row>
            </template>
          </template>

          <v-row
            v-if="
              obj.univYn === 'Y' &&
                schoolFileUploadUseYn === 'Y' &&
                schoolAble(-1)
            "
            class="mt-2"
          >
            <v-col cols="12" class="btn-post-wrap">
              <CVFileUpload
                ref="objFile"
                :label="itemLabel('schoolFile')"
                :bucketType="'temp'"
                :sectionKey="'school_temp'"
                :maxSize="itemLength('schoolFile')"
                :rules="[rules.required('schoolFile', true)]"
                :existingFileId="obj.schoolFileId"
                :isReadonly="isReadonly"
                @upload="uploadFile"
                @delete="deleteFile"
              ></CVFileUpload>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="d-md-none d-block mt-2">
              <i-btn elevation="0" color="primary" block @click="add"
                >저장</i-btn
              >
            </v-col>
          </v-row>
        </div>
      </v-form>
      <v-alert v-if="submitErrorAlert" dense outlined type="error">
        {{ submitErrorMessage }}
      </v-alert>
      <v-divider v-if="!isReadonly"></v-divider>
      <v-form ref="updateForm" :readonly="isReadonly">
        <div v-for="(item, i) in schools" :key="'school' + i">
          <v-divider :key="'schdivider-' + i" v-if="i != 0"></v-divider>
          <v-row>
            <v-col
              cols="12"
              :class="{ 'col-md-11': !isReadonly, 'col-md-12': isReadonly }"
            >
              <v-row>
                <v-col cols="12" class="col-md">
                  <!-- 학사 -->
                  <DirectInputSelect
                    v-maxlength="'school_type'"
                    :useDirect="itemDirectInput('schoolType') == 'Y'"
                    :items="itemArray('schoolType')"
                    :label="itemLabel('schoolType')"
                    v-model="item.schoolType"
                    outlined
                    dense
                    hide-details="auto"
                    :rules="[rules.required('schoolType')]"
                    @change="change(i)"
                    :readonly="isReadonly"
                    :class="leftRoundedClass"
                  />
                </v-col>
                <v-col
                  cols="6"
                  class="col-md"
                  :class="colclass"
                  v-if="item.testYn === 'N'"
                >
                  <!-- 입학 -->
                  <CommonDatePicker
                    :readonly="isReadonly"
                    :label="itemLabel('schoolSdate')"
                    useMaxCurrentDate
                    :rules="[rules.required('schoolSdate')]"
                    v-model="item.startDate"
                    :disabled="!schoolAble(i)"
                    @change="save(i)"
                    :type="schoolTermFormat === 'YYYY.MM' ? 'month' : 'date'"
                  />
                </v-col>
                <v-col
                  cols="6"
                  class="col-md"
                  :class="colclass"
                  v-if="item.testYn === 'N'"
                >
                  <DirectInputSelect
                    :useDirect="itemDirectInput('schoolStype') == 'Y'"
                    v-model="item.schoolStype"
                    v-maxlength="'school_stype'"
                    :items="itemArray('schoolStype')"
                    :label="itemLabel('schoolStype')"
                    outlined
                    dense
                    hide-details="auto"
                    :rules="[rules.required('schoolStype')]"
                    @change="save(i)"
                    :class="rrzrclass"
                    :readonly="isReadonly"
                    :disabled="!schoolAble(i)"
                  />
                </v-col>
                <v-col
                  cols="6"
                  class="col-md"
                  :class="colclass"
                  v-if="item.testYn === 'N'"
                >
                  <!-- 졸업일 -->
                  <CommonDatePicker
                    :readonly="isReadonly"
                    :label="itemLabel('schoolEdate')"
                    :rules="[rules.required('schoolEdate')]"
                    v-model="item.endDate"
                    :disabled="!schoolAble(i)"
                    :min="item.startDate"
                    @change="save(i)"
                    :type="schoolTermFormat === 'YYYY.MM' ? 'month' : 'date'"
                  />
                </v-col>
                <v-col
                  cols="6"
                  class="col-md"
                  :class="colclass"
                  v-if="item.testYn === 'Y'"
                >
                  <CommonDatePicker
                    :readonly="isReadonly"
                    label="합격일자"
                    useMaxCurrentDate
                    :rules="[rules.required('schoolEdate')]"
                    v-model="item.passDate"
                    :disabled="!schoolAble(i)"
                    @change="save(i)"
                    :type="schoolTermFormat === 'YYYY.MM' ? 'month' : 'date'"
                  />
                </v-col>
                <v-col cols="6" class="col-md" :class="colclass">
                  <DirectInputSelect
                    :useDirect="itemDirectInput('schoolEtype') == 'Y'"
                    v-model="item.schoolEtype"
                    v-maxlength="'school_etype'"
                    :items="itemArray('schoolEtype')"
                    :label="itemLabel('schoolEtype')"
                    outlined
                    dense
                    hide-details="auto"
                    @change="save(i)"
                    :rules="[rules.required('schoolEtype')]"
                    :class="rrzrclass"
                    :readonly="isReadonly"
                    :disabled="!schoolAble(i)"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col class="d-none d-md-block pl-3 col-md-1" v-if="!isReadonly">
              <i-btn
                elevation="0"
                block
                color="normal"
                outlined
                @click="remove(i)"
                >삭제</i-btn
              >
            </v-col>
          </v-row>
          <template v-if="item.testYn === 'N'">
            <v-row :class="rowclass">
              <v-col cols="6" class="col-md" :class="colclass">
                <CollectionAutoComplete
                  v-model="item.schoolName"
                  :directInput="itemDirectInput('schoolName')"
                  :collectionType="
                    item.schoolType === '고등학교' ? 'high' : 'grad'
                  "
                  :rules="[
                    rules.required('schoolName', true),
                    rules.required('schoolName'),
                  ]"
                  itemKey="school"
                  :disabled="!schoolAble(i)"
                  :label="itemLabel('schoolName')"
                  :readonly="isReadonly"
                  :campusShow="item.schoolType === '고등학교' ? false : true"
                  @change:item="item => autocomsetName(i, item)"
                  @keydown.tab="item => autocomsetName(-1, item)"
                />
              </v-col>
              <v-col
                cols="1"
                class="col-md-2"
                :class="colclass"
                v-if="item.univYn === 'Y' || item.schoolType === '고등학교'"
              >
                <i-select
                  v-model="item.schoolDayNight"
                  :items="['주간', '야간']"
                  :label="itemLabel('schoolDayNight')"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="[
                    rules.required('schoolDayNight', true),
                    rules.required('schoolDayNight'),
                  ]"
                  autocomplete="false"
                  :readonly="isReadonly"
                  clearable
                  @change="save(i)"
                  :disabled="!schoolAble(i)"
                ></i-select>
              </v-col>
              <v-col
                cols="6"
                class="col-md"
                :class="colclass"
                v-if="item.univYn === 'Y'"
              >
                <CollectionAutoComplete
                  v-model="item.schoolMajor"
                  :directInput="itemDirectInput('schoolMajor')"
                  :collectionType="
                    item.schoolType === '고등학교' ? 'high' : 'grad'
                  "
                  :rules="[
                    rules.required('schoolMajor', true),
                    rules.required('schoolMajor'),
                  ]"
                  itemKey="major"
                  :disabled="!schoolAble(i)"
                  :label="itemLabel('schoolMajor')"
                  :readonly="isReadonly"
                  :campusShow="obj.schoolType === '고등학교' ? false : true"
                  @keydown.tab="item => autocomsetMajor(i, item)"
                  @change:item="item => autocomsetMajor(i, item)"
                />
              </v-col>

              <v-col
                cols="6"
                class="col-md-2"
                :class="colclass"
                v-if="item.univYn === 'Y'"
              >
                <i-text-field
                  v-model="item.schoolScore"
                  :label="itemLabel('schoolScore')"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="[
                    rules.required('schoolScore'),
                    rules.maxlength('schoolScore'),
                    v => !v || !isNaN(v) || '숫자 형식으로 입력해 주세요',
                  ]"
                  @blur="autocomsetScore(i, item)"
                  :class="lrzrclass"
                  :readonly="isReadonly"
                  :disabled="!schoolAble(i)"
                ></i-text-field>
              </v-col>
              <v-col
                cols="6"
                class="col-md-2"
                :class="colclass"
                v-if="item.univYn === 'Y'"
              >
                <DirectInputSelect
                  v-model="item.schoolScoreUnit"
                  :useDirect="itemDirectInput('schoolScore') == 'Y'"
                  :items="itemArray('schoolScore')"
                  :label="itemLabel('schoolScore') + '기준'"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="[
                    rules.required('schoolScore'),
                    rules.required('schoolScore', true),
                  ]"
                  @change="
                    save(i);
                    autocomsetScore(i, item);
                  "
                  class="rounded-l-0 rounded-r"
                  :readonly="isReadonly"
                  :disabled="!schoolAble(i)"
                />
              </v-col>
              <v-col
                cols="6"
                class="col-md-6"
                :class="colclass"
                v-if="item.univYn === 'N'"
              >
                <DirectInputSelect
                  v-maxlength="'school_gubun'"
                  :useDirect="itemDirectInput('schoolGubun') == 'Y'"
                  v-model="item.schoolGubun"
                  :items="itemArray('schoolGubun')"
                  label="계열"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="[
                    rules.required('schoolGubun'),
                    rules.maxlength('schoolGubun'),
                  ]"
                  @change="save(i)"
                  class="rounded-l-0 rounded-r"
                  :readonly="isReadonly"
                  :disabled="!schoolAble(i)"
                />
              </v-col>
            </v-row>
            <v-row
              :class="rowclass"
              v-if="
                schoolMajorEtcUseYn == 'Y' &&
                  !['고등학교', '검정고시'].includes(item.schoolType)
              "
              :key="'itemEtc' + i"
            >
              <i-text-field
                v-maxlength="'school_major_etc'"
                v-model="item.schoolMajorEtc"
                :label="itemLabel('schoolMajorEtc')"
                outlined
                dense
                @blur="save(i)"
                :hint="template.opts.schoolMajorEtc.oGuide"
                hide-details="auto"
                :disabled="!schoolAble(i)"
                :rules="[rules.required('schoolMajorEtc')]"
              />
            </v-row>
            <v-row
              :class="rowclass"
              v-if="
                schoolEtcUseYn == 'Y' &&
                  ['석사', '박사'].some(
                    v => item.schoolType && item.schoolType.includes(v),
                  )
              "
              :key="'itemSchoolEtc' + i"
            >
              <i-text-field
                v-maxlength="'school_etc'"
                v-model="item.schoolEtc"
                :label="itemLabel('schoolEtc')"
                outlined
                dense
                @blur="save(i)"
                :hint="template.opts.schoolEtc.oGuide"
                hide-details="auto"
                :rules="[rules.required('schoolEtc')]"
              />
            </v-row>
          </template>

          <template v-if="item.univYn === 'Y' && multiSubMajorUseYn === 'Y'">
            <v-row
              class="d-flex align-center justify-end mt-1"
              v-if="!isReadonly"
            >
              <v-icon
                class="cursor  hover-opacity"
                v-show="!item.deleteAble"
                @click="addMajorSub(i)"
              >
                {{ mdiAdd }}</v-icon
              >

              <v-icon
                @click="item.deleteAble = !item.deleteAble"
                :color="item.deleteAble ? '#F44336' : null"
                class="ml-2 cursor hover-opacity"
              >
                {{ mdiEdit }}</v-icon
              >
            </v-row>
            <template v-for="(subItem, _index) in item.majorSubList">
              <v-row :class="rowclass" :key="'subItem' + _index">
                <v-col cols="6" class="col-md-4" :class="colclass">
                  <i-select
                    v-model="subItem.schoolMajorSubType"
                    :items="subMajorItems"
                    label="전공추가선택"
                    outlined
                    dense
                    hide-details="auto"
                    :rules="[rules.required('schoolMajorSub')]"
                    @change="save(i)"
                    class="rounded-l rounded-r-0"
                    :readonly="isReadonly"
                    :disabled="!schoolAble(i)"
                  >
                    <template #prepend v-if="item.deleteAble && !isReadonly">
                      <v-icon
                        :disabled="!schoolAble(i)"
                        color="#F44336"
                        class="hover-opacity cursor"
                        @click="
                          item.majorSubList.length > 1 &&
                            item.majorSubList.splice(_index, 1),
                            (item.deleteAble = false),
                            save(i)
                        "
                      >
                        {{ mdiDelete }}
                      </v-icon>
                    </template></i-select
                  >
                </v-col>
                <v-col cols="6" class="col-md-8" :class="colclass">
                  <CollectionAutoComplete
                    v-model="subItem.schoolMajorSub"
                    :directInput="itemDirectInput('schoolMajor')"
                    :rules="[
                      rules.required('schoolMajorSub', true),
                      rules.maxlength('schoolMajorSub'),
                    ]"
                    itemKey="major"
                    :disabled="!schoolAble(i)"
                    :label="itemLabel('schoolMajor')"
                    :readonly="isReadonly"
                    @change:item="item => autocomsetSubMajor(i, item, _index)"
                  />
                </v-col>
              </v-row>
              <v-row
                :class="rowclass"
                v-if="schoolMajorEtcUseYn == 'Y'"
                :key="'subItemEtc' + _index"
              >
                <i-text-field
                  v-maxlength="'school_major_etc'"
                  v-model="subItem.schoolMajorSubEtc"
                  :label="itemLabel('schoolMajorEtc')"
                  outlined
                  dense
                  @blur="save(i)"
                  :disabled="!schoolAble(i)"
                  :hint="template.opts.schoolMajorEtc.oGuide"
                  hide-details="auto"
                  :rules="[
                    v =>
                      (!subItem.schoolMajorSub &&
                        !subItem.schoolMajorSubType) ||
                      rules.required('schoolMajorEtc')(v),
                  ]"
                >
                  <template #prepend v-if="item.deleteAble">
                    <div style="height:24px;width:24px;"></div>
                  </template>
                </i-text-field>
              </v-row>
            </template>
          </template>
          <v-row
            v-if="
              item.univYn === 'Y' &&
                schoolFileUploadUseYn === 'Y' &&
                schoolAble(i)
            "
            class="mt-2"
          >
            <v-col cols="12" class="btn-post-wrap">
              <CVFileUpload
                :label="itemLabel('schoolFile')"
                :sectionKey="'school' + item.seq"
                :rules="[rules.required('schoolFile')]"
                :existingFileId="item.schoolFileId"
                :maxSize="itemLength('schoolFile')"
                :isReadonly="isReadonly"
                @upload="uploadFile"
                @delete="deleteFile"
              ></CVFileUpload>
            </v-col>
          </v-row>
          <v-row v-if="!isReadonly">
            <v-col cols="12" class="d-md-none d-block mt-2">
              <i-btn
                elevation="0"
                color="normal"
                block
                outlined
                @click="remove(i)"
                >삭제</i-btn
              >
            </v-col>
          </v-row>
        </div>
      </v-form>
      <template v-if="schoolMoreQuestionUseYn == 'Y'">
        <i-textarea
          class="mt-2"
          :readonly="isReadonly"
          dense
          ref="moreSchool"
          @blur="saveMoreSchool"
          @keydown.enter="saveMoreSchool"
          persistent-hint
          outlined
          hide-details="auto"
          :label="
            (template.opts.schoolMoreQuestions.oRequireYn == 'Y' ? '*' : '') +
              template.opts.schoolMoreQuestions.oGuide
          "
          v-model="moreQuestions"
          :rules="[
            rules.minlength('schoolMoreQuestions'),
            rules.required('schoolMoreQuestions'),
            rules.maxLength('schoolMoreQuestions'),
          ]"
          :counter="opts.schoolMoreQuestions.oMaxLength"
        >
        </i-textarea>
      </template>
    </div>
  </div>
</template>

<script>
import { LoadingMixin } from '@/mixin/loading.js';
import {
  mdiCalendarBlank,
  mdiMinusCircleOutline,
  mdiPencilOutline,
  mdiPlus,
  mdiInformationOutline,
} from '@mdi/js';
import CommonDatePicker from '@/components/common/CommonDatePicker.vue';
import CVFileUpload from './CVFileUpload.vue';
import DirectInputSelect from '@/components/common/DirectInputSelect.vue';
import moment from 'moment';
import { resumeType } from '@/const/resumeType';
import { API } from '@/api/network';
import { snack } from '@/plugins/dialog/api';
import CollectionAutoComplete from '@/components/common/CollectionAutoComplete.vue';

const defaultSubMajor = {
  schoolMajorSub: '',
  schoolMajorSubEtc: '',
  schoolMajorSubType: '',
  schoolMajorSubLClass: '',
  schoolMajorSubDirectYn: null,
  isSubMajorFocused: false,
};

export default {
  mixins: [LoadingMixin],

  props: {
    itemArray: {
      type: Function,
      default: () => {},
    },
    itemDirectInput: {
      type: Function,
      default: () => {},
    },

    applNo: { Type: String },
    template: { type: Object },
    info: { type: Object },
    opts: { type: Object },
    rules: { type: Object },
    dynamicScreenTagClass: { type: Object },
    leftRoundedClass: { type: Object },
    rightRoundedClass: { type: Object },
    isReadonly: {
      type: Boolean,
      default: function() {
        return true;
      },
    },
  },
  components: {
    CommonDatePicker,
    CVFileUpload,
    DirectInputSelect,

    CollectionAutoComplete,
  },
  computed: {
    itemsMaxSize() {
      return +this.opts?.school?.oMaxLength || 0;
    },
    canAdd() {
      return (
        !this.opts?.school?.oMaxLength ||
        this.opts.school?.oMaxLength > this.schools.length
      );
    },
    mdiDelete() {
      return mdiMinusCircleOutline;
    },
    mdiEdit() {
      return mdiPencilOutline;
    },
    mdiAdd() {
      return mdiPlus;
    },
    mdiInformationOutline() {
      return mdiInformationOutline;
    },
    rowclass: function() {
      return {
        'mt-2':
          this.$vuetify.breakpoint.name != 'sm' &&
          this.$vuetify.breakpoint.name != 'xs',
      };
    },
    colclass: function() {
      return {
        'mt-2':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
      };
    },
    lrzrclass: function() {
      return {
        'rounded-0':
          this.$vuetify.breakpoint.name != 'sm' &&
          this.$vuetify.breakpoint.name != 'xs',
        'rounded-l':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
        'rounded-r-0':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
      };
    },
    rrzrclass: function() {
      return {
        'rounded-0':
          this.$vuetify.breakpoint.name != 'sm' &&
          this.$vuetify.breakpoint.name != 'xs',
        'rounded-r':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
        'rounded-l-0':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
      };
    },
    zeroRoundedClass: function() {
      return {
        'rounded-0':
          this.$vuetify.breakpoint.name != 'sm' &&
          this.$vuetify.breakpoint.name != 'xs',
      };
    },
  },
  mounted() {
    this.setting();
  },
  data: () => ({
    moreQuestions: '',
    mdiCalendarBlank,
    obj: null,
    school: '',
    schools: [],
    itemDelimeter: '#',
    multiSubMajorUseYn: 'N',
    schoolFileUploadUseYn: 'N',
    schoolMoreQuestionUseYn: 'N',
    schoolMajorEtcUseYn: 'N',
    schoolEtcUseYn: 'N',
    schoolTermFormat: '',
    subMajorItems: ['부전공', '복수전공'],
    itemSeq: 1,
    saveAlert: false,
    deleteAlert: false,
    submitErrorAlert: false,
    submitErrorMessage: '',
    isSetWord: false,
  }),
  watch: {
    saveAlert: function() {
      if (this.saveAlert) {
        setTimeout(() => {
          this.saveAlert = false;
        }, 2000);
      }
    },
    deleteAlert: function() {
      if (this.deleteAlert) {
        setTimeout(() => {
          this.deleteAlert = false;
        }, 2000);
      }
    },
    submitErrorAlert: function() {
      if (this.submitErrorAlert) {
        setTimeout(() => {
          this.submitErrorAlert = false;
        }, 10000);
      }
    },
  },
  methods: {
    itemLabel: function(key) {
      var label = this.template[key];
      if (this.opts && this.opts.hasOwnProperty(key)) {
        label =
          this.opts[key].oRequireYn === 'Y'
            ? '*' + this.$t(label)
            : this.$t(label);
      }
      return label;
    },
    itemLength: function(key) {
      var length = 0;
      if (this.opts && this.opts.hasOwnProperty(key)) {
        length = this.opts[key].oLength ? this.opts[key].oLength : 2;
      }
      return length;
    },

    setting: function() {
      let $this = this;
      Object.assign(this, {
        multiSubMajorUseYn: 'N',
        schoolFileUploadUseYn: 'N',
        schoolMoreQuestionUseYn: 'N',
        schoolMajorEtcUseYn: 'N',
        schoolEtcUseYn: 'N',
      });
      const resumeItems = resumeType.typeSchool[this.template.typeSchool];
      if (resumeItems) {
        this.school = 'Y';
        this.multiSubMajorUseYn = resumeItems.includes('schoolMajorSub')
          ? 'Y'
          : 'N';
        this.schoolFileUploadUseYn = resumeItems.includes('schoolFile')
          ? 'Y'
          : 'N';
        this.schoolMajorEtcUseYn = resumeItems.includes('schoolMajorEtc')
          ? 'Y'
          : 'N';
        this.schoolEtcUseYn = resumeItems.includes('schoolEtc') ? 'Y' : 'N';
      }
      this.schoolMoreQuestionUseYn =
        this.template.moreSchool == 'Y' ? 'Y' : 'N';
      if (this.schoolMoreQuestionUseYn == 'Y') {
        this.fetchMoreSchool();
      }
      if (this.opts) {
        for (let key in this.opts) {
          let prop = this.opts[key];
          if (
            prop.id.cvColumn === 'schoolSdate' ||
            prop.id.cvColumn === 'schoolEdate'
          ) {
            $this.schoolTermFormat = prop.oFormat;
          }
        }
      }
      this.settingData();
      this.obj = this.defaultObj();
    },
    settingData: function() {
      if (this.info && this.info.schools && this.info.schools.length > 0) {
        this.itemSeq = this.info.schools[0].id.seq;
        this.schools = [];
        let $this = this;
        this.info.schools.forEach(function(v) {
          var startDate = '';

          var endDate = '';

          if (v.schoolSdate)
            startDate = moment(v.schoolSdate).format($this.schoolTermFormat);
          if (v.schoolEdate)
            endDate = moment(v.schoolEdate).format($this.schoolTermFormat);

          let obj = {
            seq: v.id.seq,
            schoolDayNight: !v.schoolDayNight
              ? null
              : v.schoolDayNight === 'DAY'
              ? '주간'
              : '야간',
            schoolType: v.schoolType,
            schoolStype: v.schoolStype,
            schoolEtype: v.schoolEtype,
            // 만약 업데이트 폼에서 학교명 지우고, 저장하면 학교명은 없는 데 캠퍼스는 있어서 [본교]만 나옴
            schoolName: v.schoolCampus
              ? v.schoolName
                ? `${v.schoolName}[${v.schoolCampus}]`
                : null
              : v.schoolName,
            schoolCampus: v.schoolCampus,
            schoolRegion: v.schoolRegion,
            schoolEstType: v.schoolEstType,
            schoolAdres: v.schoolAdres,
            schoolLink: v.schoolLink,
            schoolMajor: v.schoolMajor,
            schoolMajorEtc: v.schoolMajorEtc,
            schoolScore: v.schoolScore,
            schoolScoreUnit: String(v.schoolScoreUnit),
            schoolGubun: v.schoolGubun,
            schoolFileId: v.schoolFileId ? v.schoolFileId : null,
            schoolDirectYn: v.schoolDirectYn,
            schoolMajorDirectYn: v.schoolMajorDirectYn,
            testYn: v.schoolType === '검정고시' ? 'Y' : 'N',
            univYn:
              v.schoolType === '검정고시' || v.schoolType === '고등학교'
                ? 'N'
                : 'Y',
            isNameFocused: false,
            isMajorFocused: false,
            isScoreFocused: false,
            start: '',
            end: '',
            pass: '',
            startDate: startDate,
            endDate: v.schoolType === '검정고시' ? '' : endDate,
            passDate: v.schoolType === '검정고시' ? endDate : '',
            deleteAble: false,
            schoolEtc: v.schoolEtc,
          };

          const majorSubList = [];

          ['', 1, 2].forEach(num => {
            const [
              schoolMajorSub,
              schoolMajorSubType,
              schoolMajorSubDirectYn,
              schoolMajorSubEtc,
              schoolMajorSubLClass,
            ] = [
              v[`schoolMajorSub${num}`],
              v[`schoolMajorSub${num}Type`],
              v[`schoolMajorSub${num}DirectYn`],
              v[`schoolMajorSub${num}Etc`],
              v[`schoolMajorSub${num}LClass`],
            ];

            [
              schoolMajorSub,
              schoolMajorSubType,
              schoolMajorSubDirectYn,
              schoolMajorSubEtc,
            ].some(c => c) &&
              majorSubList.push({
                schoolMajorSub,
                schoolMajorSubType,
                schoolMajorSubDirectYn,
                schoolMajorSubEtc,
                schoolMajorSubLClass,
                isSubMajorFocused: false,
              });
          });
          if (!majorSubList.length) majorSubList.push({ ...defaultSubMajor });
          obj.majorSubList = majorSubList;

          $this.schools.push(obj);
          $this.itemSeq =
            $this.itemSeq < v.id.seq ? v.id.seq + 1 : $this.itemSeq + 1;
        });
      }
    },

    // 세이브폼이나 업데이트폼이나 둘 다 change schoolType 바꾸면 change가 된다

    change: function(i) {
      let schoolObj = i === -1 ? this.obj : this.schools[i];
      if (schoolObj.schoolType === '검정고시') {
        schoolObj.testYn = 'Y';
        schoolObj.univYn = 'N';
      } else if (schoolObj.schoolType === '고등학교') {
        schoolObj.testYn = 'N';
        schoolObj.univYn = 'N';
      } else {
        schoolObj.testYn = 'N';
        schoolObj.univYn = 'Y';
      }

      //INIT SCHOOL OBJECT
      schoolObj.schoolDayNight = '';
      schoolObj.schoolStype = '';
      schoolObj.schoolEtype = '';
      schoolObj.schoolName = '';
      schoolObj.schoolCampus = '';
      schoolObj.schoolEstType = '';
      schoolObj.schoolAdres = '';
      schoolObj.schoolLink = '';
      schoolObj.schoolScore = '';
      schoolObj.schoolScoreUnit = '';
      schoolObj.schoolMajor = '';
      schoolObj.schoolMajorSub = '';
      schoolObj.schoolMajorSubType = '';
      schoolObj.schoolMajorSubEtc = '';
      schoolObj.schoolEtc = '';
      schoolObj.schoolDirectYn = null;
      schoolObj.schoolMajorDirectYn = null;
      schoolObj.schoolMajorSubDirectYn = null;
      schoolObj.schoolGubun = '';
      schoolObj.start = '';
      schoolObj.end = '';
      schoolObj.pass = '';
      schoolObj.startDate = '';
      schoolObj.endDate = '';
      schoolObj.passDate = '';
      schoolObj.majorSubList = [{ ...defaultSubMajor }];
    },
    autocomsetName: function(i, item) {
      // 학교 컴포넌트의 2번째 row를 건들때 item 에 검정고시는 없다 2번째 row가 없기때문에

      var tmp = i === -1 ? this.obj : this.schools[i];
      // 이 놈이 절름발이입니다. schoolName는 XX고등학교인데, 나머지들이 다 '' . null 이라도 그것을 다 바인딩해서 save 해버림 ....
      if (item) {
        tmp.schoolName = item.campusName
          ? `${item.schoolName}[${item.campusName}]`
          : item.schoolName;

        if (item.hasOwnProperty('region')) tmp.schoolRegion = item.region;
        if (item.hasOwnProperty('link')) tmp.schoolLink = item.link;
        if (item.hasOwnProperty('campusName'))
          tmp.schoolCampus = item.campusName;
        if (item.hasOwnProperty('estType')) tmp.schoolEstType = item.estType;
        if (item.hasOwnProperty('adres')) tmp.schoolAdres = item.adres;

        if (item.hasOwnProperty('directYn')) {
          tmp.schoolDirectYn = item.directYn;
        } else {
          tmp.schoolDirectYn = 'N';
        }
        // 대학교 명에 고등학교의 이름만 바인딩 되고 저장이 되는 경우 때문에
        if (tmp.schoolName && !tmp.schoolDirectYn) {
          //school은 필숫값이 때문에 만약 고등학교가 바인딩 된다고 해도 학교명이 비어있으면 제출 시 걸림
          tmp.schoolName = '';
          tmp.schoolRegion = '';
          tmp.schoolLink = '';
          tmp.schoolCampus = '';
          tmp.schoolEstType = '';
          tmp.schoolAdres = '';
          tmp.schoolDirectYn = null;
          snack.danger('학교 정보를 확인해주세요');
        }
      } else {
        tmp.schoolName = '';
        tmp.schoolRegion = '';
        tmp.schoolLink = '';
        tmp.schoolCampus = '';
        tmp.schoolEstType = '';
        tmp.schoolAdres = '';
        tmp.schoolDirectYn = null;
      }

      tmp.isNameFocused = false;
      this.isSetWord = true;
      if (i !== -1) this.save(i);
    },
    setFocusNameEvent: function(i, focus) {
      if (this.isSetWord) {
        this.isSetWord = false;
        return;
      }
      var tmp = i === -1 ? this.obj : this.schools[i];
      tmp.isNameFocused = focus;
    },
    autocomsetMajor: function(i, item) {
      var tmp = i === -1 ? this.obj : this.schools[i];

      if (item) {
        tmp.schoolMajor = item.name;
        if (item.hasOwnProperty('directYn')) {
          tmp.schoolMajorDirectYn = item.directYn;
        } else {
          tmp.schoolMajorDirectYn = 'N';
        }
      } else {
        tmp.schoolMajor = '';
        tmp.schoolMajorDirectYn = null;
      }
      tmp.isMajorFocused = false;
      this.isSetWord = true;
      if (i !== -1) this.save(i);
    },

    autocomsetScore(i, item) {
      var tmp = i === -1 ? this.obj : this.schools[i];

      if (item) {
        tmp.schoolScoreUnit = item.schoolScoreUnit;
        if (
          item.hasOwnProperty('schoolScoreUnit') &&
          parseFloat(tmp.schoolScore) > parseFloat(tmp.schoolScoreUnit)
        ) {
          tmp.schoolScore = '';
          snack.danger('학점이 총점보다 높습니다');
          return;
        } else if (
          !item.hasOwnProperty('schoolScoreUnit') &&
          parseFloat(tmp.schoolScore) <= parseFloat(tmp.schoolScoreUnit)
        ) {
          tmp.schoolScore = item.schoolScore;
        }
      }
      tmp.isScoreFocused = false;
      this.isSetWord = true;

      if (i !== -1) this.save(i);
    },
    setFocusMajorEvent: function(i, focus) {
      if (this.isSetWord) {
        this.isSetWord = false;
        return;
      }
      var tmp = i === -1 ? this.obj : this.schools[i];
      tmp.isMajorFocused = focus;
    },
    autocomsetSubMajor: function(i, item, index) {
      var tmp =
        i === -1
          ? this.obj.majorSubList[index]
          : this.schools[i].majorSubList[index];

      if (item) {
        tmp.schoolMajorSub = item.name;
        tmp.schoolMajorSubLClass = item.class;
        if (item.hasOwnProperty('directYn')) {
          tmp.schoolMajorSubDirectYn = item.directYn;
        } else {
          tmp.schoolMajorSubDirectYn = 'N';
        }
      } else {
        tmp.schoolMajorSub = '';
        tmp.schoolMajorSubDirectYn = null;
        tmp.schoolMajorSubLClass = '';
      }

      tmp.isSubMajorFocused = false;
      this.isSetWord = true;
      if (i !== -1) this.save(i);
    },
    setFocusSubMajorEvent: function(i, focus, index) {
      if (this.isSetWord) {
        this.isSetWord = false;
        return;
      }
      var tmp =
        i === -1
          ? this.obj.majorSubList[index]
          : this.schools[i].majorSubList[index];
      tmp.isSubMajorFocused = focus;
    },
    defaultObj: function() {
      let obj = {
        seq: this.itemSeq++,
        schoolDayNight: '',
        schoolType: '',
        schoolStype: '',
        schoolEtype: '',
        schoolName: '',
        schoolCampus: '',
        schoolRegion: '',
        schoolEstType: '',
        schoolAdres: '',
        schoolLink: '',
        schoolMajor: '',
        schoolMajorEtc: '',
        schoolScore: '',
        schoolScoreUnit: '',
        schoolDirectYn: null,
        schoolMajorDirectYn: null,
        schoolFileId: null,
        schoolGubun: '',
        testYn: 'N',
        univYn: 'Y',
        isNameFocused: false,
        isMajorFocused: false,
        isScoreFocused: false,
        deleteAble: false,
        start: '',
        end: '',
        pass: '',
        startDate: '',
        endDate: '',
        schoolEtc: '',
        passDate: '',
        majorSubList: [{ ...defaultSubMajor }],
      };

      return obj;
    },
    schoolAble: function(i) {
      var sch = i === -1 ? this.obj : this.schools[i];
      return sch.schoolType && sch.schoolType !== '';
    },
    add: function() {
      if (!this.canAdd)
        return this.$showAlert(
          '최대 입력 가능 갯수 : ' + `${this.opts.project.oMaxLength}`,
        );

      if (this.$refs.saveForm.validate()) {
        this.save(-1);
      }
    },
    async fetchMoreSchool() {
      const { data } = await API.getAuthJson('/cv/moreQuestions', {
        annoId: this.$route.params.annoId,
        applNo: this.applNo,
        cvColumn: 'moreSchool',
      });
      this.moreQuestions = data.answer;
    },
    async saveMoreSchool() {
      if (!this.moreQuestions || this.isReadonly) return;
      if (!this.$refs.moreSchool.validate()) return;
      try {
        await API.postAuthJson('/cv/moreQuestions', {
          id: {
            annoId: this.$route.params.annoId,
            applNo: this.applNo,
            cvColumn: 'moreSchool',
          },
          moreQuestions: this.moreQuestions ?? '',
        });
        snack.info(`저장되었습니다.`);
      } catch (error) {
        console.error(error);
      }
    },
    remove: function(i) {
      this.delete(i);
    },

    valid() {
      //필수 여부 체크
      if (
        this.opts &&
        this.opts.school &&
        this.opts.school.oRequireYn &&
        this.opts.school.oRequireYn == 'Y' &&
        this.schools.length < 1
      ) {
        this.submitErrorMessage = this.$t(
          '최소 1개의 정보는 존재하여야 합니다.',
        );
        this.submitErrorAlert = true;
        return false;
      }

      return this.$refs.updateForm.validate();
    },
    async save(i) {
      if (this.isReadonly) return;
      await this.$nextTick();
      var item = i === -1 ? this.obj : this.schools[i];

      const id = {
        annoId: this.$route.params.annoId,
        seq: item.seq,
      };

      var pattern = /[^(가-힣ㄱ-ㅎㅏ-ㅣa-zA-Z0-9)]/gi; // 특수문자 제거
      const p = {
        id: id,
        schoolName: !item.schoolName
          ? ''
          : item.schoolName.split('[')[0].trim(),
        schoolDayNight: !item.schoolDayNight
          ? null
          : item.schoolDayNight === '주간'
          ? 'DAY'
          : 'NIGHT',
        schoolCampus: item.schoolCampus,
        schoolRegion: item.schoolRegion,
        schoolEstType: item.schoolEstType,
        schoolAdres: item.schoolAdres,
        schoolLink: item.schoolLink,
        schoolScore: item.schoolScore,
        schoolScoreUnit: item.schoolScoreUnit,
        schoolSdate: item.startDate.replace(pattern, ''),
        schoolEdate:
          item.testYn === 'Y'
            ? item.passDate.replace(pattern, '')
            : item.endDate.replace(pattern, ''),
        schoolStype: item.schoolStype,
        schoolEtype: item.schoolEtype,
        schoolType: item.schoolType,
        schoolGubun: item.schoolGubun,
        schoolMajor: item.schoolMajor,
        schoolMajorEtc: item.schoolMajorEtc,
        schoolDirectYn: item.schoolDirectYn,
        schoolMajorDirectYn: item.schoolMajorDirectYn,
        schoolFileId: item.schoolFileId,
        schoolEtc: item.schoolEtc,
        schoolMajorSubDirectYn: item.schoolMajorSubDirectYn,
        schoolMajorSub: item.schoolMajorSub,
        schoolMajorSubType: item.schoolMajorSubType,
      };

      Object.assign(
        p,
        item.majorSubList
          .filter(f => Object.values(f).some(s => s))
          .reduce((a, c, index) => {
            const num = index == 0 ? '' : index + 1;
            return Object.assign(a, {
              [`schoolMajorSub${num}`]: c.schoolMajorSub,
              [`schoolMajorSub${num}Type`]: c.schoolMajorSubType,
              [`schoolMajorSub${num}DirectYn`]: c.schoolMajorSubDirectYn,
              [`schoolMajorSub${num}Etc`]: c.schoolMajorSubEtc,
              [`schoolMajorSub${num}LClass`]: c.schoolMajorSubLClass,
            });
          }, {}),
      );

      this.$emit('save', p, 'school', i);
    },
    savecallback: function(res, i) {
      var item = i === -1 ? this.obj : this.schools[i];

      if (res.status !== 200) {
        console.log('SCHOOL SAVE FAIL');
      } else snack.info(`저장되었습니다.`);
      //SAVE FORM
      if (i === -1) {
        this.schools.push(this.obj);
        this.obj = this.defaultObj();
        this.$refs.saveForm.resetValidation();

        if (item.schoolFileId) {
          this.applyFile(item.schoolFileId);
        }
      }
    },
    delete: function(i) {
      this.showLoading();
      const p = {
        annoId: this.$route.params.annoId,
        seq: this.schools[i].seq,
      };
      this.$emit('delete', p, 'school', i);
    },
    deletecallback: function(res, i) {
      if (res.status !== 200) {
        console.log('SCHOOL DELETE FAIL');
      } else {
        this.schools.splice(i, 1);
        snack.danger(`삭제되었습니다.`);
      }
      this.hideLoading();
    },
    uploadFile(sectionKey, fileId) {
      if (sectionKey.indexOf('temp') > -1) {
        this.obj.schoolFileId = String(fileId);
      } else {
        var seq = sectionKey.substring('school'.length, sectionKey.length);
        var idx = -1;
        this.schools.forEach(function(v, i) {
          if (String(v.seq) === seq) {
            v.schoolFileId = fileId;
            idx = i;
          }
        });
        if (idx !== -1) this.save(idx);
      }
    },
    deleteFile(sectionKey) {
      var seq = sectionKey.substring('school'.length, sectionKey.length);
      var idx = -1;
      this.schools.forEach(function(v, i) {
        if (String(v.seq) === seq) {
          v.schoolFileId = '';
          idx = i;
        }
      });
      if (idx !== -1) this.save(idx);
    },
    applyFile(fileId) {
      this.$emit('applyFile', 'school', fileId);
    },
    applyFilecallback: function(res) {
      if (res.status !== 200) {
        console.log('SCHOOL FILE APPLY FAIL');
      } else {
        this.$refs.objFile.initFiles();
      }
    },
    addMajorSub(index) {
      const target =
        index == -1 ? this.obj.majorSubList : this.schools[index].majorSubList;
      if (target.length <= 2) target.push({ ...defaultSubMajor });
      else this.$snackbar('최대 3개 까지 입력 가능합니다.');
    },
  },
};
</script>

<style>
.v-parallax {
  height: 100% !important;
}
.guide-common {
  min-height: calc(100vh - 64px - 122px);
}

.item-common .header .title {
  font-size: 18px;
  font-weight: bold;
  line-height: 2.67;
  letter-spacing: -0.36px;
  color: #292929;
}
.item-common .header .desc {
  margin-top: 10px;
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: -0.28px;
  color: #555555;
}
.item-common .body {
  margin-top: 22px;
}
.item-common .body .v-divider {
  margin-top: 20px;
  margin-bottom: 20px;
}

.item-common .row {
  margin: 0px;
}
.item-common .col {
  padding: 0px;
}
.item-common .v-text-field {
  min-height: 36px;
}
.btn-post-wrap {
  position: relative;
}
.btn-post {
  position: absolute;
  top: 6px;
  right: 5px;
}

.type-school .sub-title-standard {
  position: relative;
}
.type-school .sub-title-standard .v-input__slot {
  padding-left: 65px !important;
}
.type-school .sub-title-standard .sub-title {
  position: absolute;
  left: 10px;
  top: 10px;
  font-size: 14px;
  font-weight: 700;
  color: #363c43;
}
</style>
